import React from 'react';

export default class Video extends React.PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			paused: true
		}
	}

	preload() {
		this.ref.load()
	}

	play() {
		this.setPaused(false)
	}

	pause() {
		this.setPaused(true)
	}

	togglePause() {
		this.setState( state => ({
			paused: !state.paused
		}))
	}

	setPaused( value ) {
		if ( this.state.paused === value ) { return }
		this.setState({
			paused: value
		}, () => {
			this.checkPlaystate()
		})

	}

	// -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  - Methods

	checkPlaystate() {

		if ( this.playPromise ) {

			// no need to try playing or pausing a video that is in a transitional
			// state. Let's check again once the promise has been executed

			this.playPromise.then(() => {
				this.playPromise = null
				this.checkPlaystate()
			})

			// skip the rest for now
			return null

		}

		if ( !this.state.paused ) {

			if ( this.state.preloaded ) {
				this.setState({ preloaded: true })
				this.ref.load()
			}

			// play and store the promise
			this.playPromise = this.ref.play()

			// ensure playPromise is a Promise
			// can't for some reason rely on `instanceof Promise`
			this.playPromise = ( typeof (this.playPromise) === 'object' && this.playPromise.then ) && this.playPromise

		} else {

			if ( this.playPromise ) {
				this.playPromise.then(() => {
					this.ref.pause()
				})
			} else {
				this.ref.pause()
			}
		}

	}

	render() {

		return (
			<video
				{ ...this.props }
				ref={ ref => this.ref = ref }
				>
				{ this.props.children }
			</video>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/video/Video.jsx